// extracted by mini-css-extract-plugin
export default {"listItem":"TXcMh49g0IFif5n7Axy7","gap":"P39DzMEJnc9ksss38rbr"};